module.exports = __webpack_public_path__ + "img/binding-bg.b902a6de.png";